/**
 * Tạo URL ảnh đã tối ưu qua imgproxy (proxy chuyển đổi ảnh của HACOM).
 * Port từ project hacom.client.web (cloudflareLoader/imgproxy) nhưng chạy
 * thuần browser: dùng path /insecure nên KHÔNG cần key/salt hay Node crypto.
 *
 * @see https://docs.imgproxy.net/usage/processing
 */
const IMGPROXY_ENDPOINT =
  process.env.REACT_APP_IMGPROXY_ENDPOINT ||
  "https://cdn-transformations.hacom.vn";

/** Base64 URL-safe (không padding), an toàn UTF-8. */
function base64url(str: string): string {
  const b64 = window.btoa(unescape(encodeURIComponent(str)));
  return b64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

interface ProxyOptions {
  width: number;
  height?: number;
  /** Gravity khi crop fill: no (bắc/trên) | so | ea | we | ce (giữa) */
  gravity?: string;
  quality?: number;
  format?: string;
}

/**
 * Sinh URL ảnh resize. Nếu có height → crop fill (vuông/khung cố định),
 * ngược lại fit theo width. Trả về undefined nếu không có src hợp lệ.
 */
export function proxyImage(
  src: string | undefined | null,
  { width, height, gravity, quality = 75, format = "webp" }: ProxyOptions
): string | undefined {
  if (!src) return undefined;
  if (src.startsWith("data:")) return src; // ảnh base64 – giữ nguyên
  if (!/^https?:\/\//i.test(src)) return src; // không phải URL tuyệt đối

  try {
    const w = Math.round(width);
    let q = quality >= 90 ? 75 : quality;

    // Thứ tự shortcode theo alphabet: f, g, h, q, rt, w
    const parts: string[] = [`f:${format}`];
    if (gravity) parts.push(`g:${gravity}`);
    if (height) parts.push(`h:${Math.round(height)}`);
    parts.push(`q:${q}`);
    parts.push(`rt:${height ? "fill" : "fit"}`);
    parts.push(`w:${w}`);

    const options = parts.join("/");
    const encoded = base64url(src);
    return `${IMGPROXY_ENDPOINT}/insecure/${options}/${encoded}.${format}`;
  } catch (error) {
    return src;
  }
}

/**
 * URL avatar vuông, sắc nét (mặc định gấp ~3x kích thước hiển thị cho màn
 * Retina), crop bám phần trên (gravity "no") để lấy đúng khuôn mặt.
 */
export function proxyAvatar(
  src: string | undefined | null,
  displaySize: number
): string | undefined {
  const px = Math.round(displaySize * 3);
  return proxyImage(src, { width: px, height: px, gravity: "no" });
}
